
import lang from './lang';

export default lang;



// WEBPACK FOOTER //
// ./src/modules/lang/index.js